"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelectSeoCleanLocationSubDirectoryPrefix = exports.useSelectBuildingNames = exports.useSelectToggleLoadingStateData = exports.getFiltersGroup = exports.useSelectAppliedStates = exports.useSelectSelectedDistrictsData = exports.useSelectCustomPlace = exports.clearSeoCleanLocationSubDirectoryPrefix = exports.setSeoCleanLocationSubDirectoryPrefix = exports.setDistrictsWithoutAppliedState = exports.setBuildingNames = exports.setAppliedStates = exports.toggleLoadingStateData = exports.removeDistrictsByStateId = exports.removeSelectedAllDistricts = exports.setDistricts = exports.removeCustomPlace = exports.setCustomPlace = exports.setCustomViewBox = exports.setViewBox = exports.getDistrictsByName = exports.getMissingDataDetails = exports.getMissingData = exports.getBuildingNames = exports.getDistricts = exports.getFilterSchema = exports.getFiltersData = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var axios_1 = __importDefault(require("axios"));
var LocalStorageManager_1 = require("../../utils/LocalStorageManager");
var reduce_1 = __importDefault(require("lodash/reduce"));
var strings_1 = require("../../helpers/strings");
var currencySlice_1 = require("../currencies/currencySlice");
var filters_1 = require("../../helpers/filters");
var getFiltersData = function () { return __awaiter(void 0, void 0, void 0, function () {
    var data, localFilters, version, response, e_1;
    var _a;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                data = {};
                localFilters = LocalStorageManager_1.get('filterList');
                version = (_b = process.env.MIX_APP_VERSION) !== null && _b !== void 0 ? _b : '';
                if (!(!localFilters || Object.keys(localFilters)[0] != version)) return [3 /*break*/, 5];
                _c.label = 1;
            case 1:
                _c.trys.push([1, 3, , 4]);
                return [4 /*yield*/, axios_1.default.get('/api/schema/filters', {
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    })];
            case 2:
                response = _c.sent();
                data = response.data.data;
                LocalStorageManager_1.set('filterList', (_a = {}, _a[version] = data, _a));
                return [3 /*break*/, 4];
            case 3:
                e_1 = _c.sent();
                // TODO: show an error
                data = {};
                return [3 /*break*/, 4];
            case 4: return [3 /*break*/, 6];
            case 5:
                // @ts-ignore
                data = localFilters[version];
                _c.label = 6;
            case 6: return [2 /*return*/, data];
        }
    });
}); };
exports.getFiltersData = getFiltersData;
//TODO: FIX axios type
exports.getFilterSchema = toolkit_1.createAsyncThunk('filters', exports.getFiltersData);
var initialState = {
    filters: null,
    customViewBox: null,
    viewBox: {
        south: 0,
        west: 0,
        north: 0,
        east: 0,
    },
    status: 'idle',
    loading: true,
    customPlace: null,
    selectedDistrictsData: [],
    loadingStateData: false,
    appliedStates: [],
    buildingNames: [],
    seoCleanLocationSubDirectoryPrefix: '',
};
var searchParamsSlice = toolkit_1.createSlice({
    name: 'searchParams',
    initialState: initialState,
    reducers: {
        setCustomPlace: function (state, action) {
            if (!action.payload) {
                return;
            }
            var address_components = action.payload.address_components;
            var placeAdministrative = '', placeLocality = '', placeSubLocality = '';
            address_components.forEach(function (component) {
                var types = component.types;
                if (types.indexOf('administrative_area_level_1') > -1 ||
                    (types === null || types === void 0 ? void 0 : types.indexOf('administrative')) > -1) {
                    placeAdministrative = component.short_name;
                }
                if (types.indexOf('locality') > -1 ||
                    (types === null || types === void 0 ? void 0 : types.indexOf('secondary')) > -1) {
                    placeLocality = component.short_name;
                }
                if (types.indexOf('sublocality_level_1') > -1) {
                    placeSubLocality = component.short_name;
                }
            });
            if (state.filters && state.filters['state']) {
                var formatAdminLevel = strings_1.formatToSnakeCase(placeAdministrative);
                state.filters['state'] = filters_1.selectOneFromFilter(toolkit_1.current(state.filters['state']), formatAdminLevel);
            }
            if (placeLocality === placeAdministrative) {
                if (state.filters &&
                    state.filters['district'] &&
                    placeSubLocality) {
                    state.filters['district'].value = [
                        strings_1.formatToSnakeCase(placeSubLocality),
                    ];
                }
            }
            else {
                if (state.filters &&
                    state.filters['district'] &&
                    placeLocality) {
                    state.filters['district'].value = [
                        strings_1.formatToSnakeCase(placeLocality),
                    ];
                }
            }
            state.customPlace = action.payload;
        },
        removeCustomPlace: function (state) {
            state.customPlace = null;
        },
        setViewBox: function (state, action) {
            state.viewBox = action.payload.viewBox;
        },
        setCustomViewBox: function (state, action) {
            state.customViewBox = action.payload.bbox;
        },
        setDistricts: function (state, action) {
            var data = action.payload.data;
            var combineData = __spreadArray(__spreadArray([], state.selectedDistrictsData), data);
            state.selectedDistrictsData = combineData.filter(function (item) {
                if (state.appliedStates.includes(String(item.parent_state_id))) {
                    return item;
                }
            });
        },
        setDistrictsWithoutAppliedState: function (state, action) {
            var data = action.payload.data;
            state.selectedDistrictsData = data;
        },
        removeSelectedAllDistricts: function (state) {
            state.selectedDistrictsData = [];
        },
        removeDistrictsByStateId: function (state, action) {
            state.selectedDistrictsData = state.selectedDistrictsData.filter(function (state) { return state.parent_state_id !== action.payload.id; });
        },
        toggleLoadingStateData: function (state, action) {
            state.loadingStateData = action.payload.loading;
        },
        setAppliedStates: function (state, action) {
            state.appliedStates = action.payload;
        },
        setBuildingNames: function (state, action) {
            state.buildingNames = action.payload.data;
        },
        setSeoCleanLocationSubDirectoryPrefix: function (state, action) {
            state.seoCleanLocationSubDirectoryPrefix = action.payload;
        },
        clearSeoCleanLocationSubDirectoryPrefix: function (state) {
            state.seoCleanLocationSubDirectoryPrefix = '';
        },
    },
    extraReducers: function (builder) {
        builder.addCase(exports.getFilterSchema.pending, function (state) {
            state.status = 'pending';
        });
        builder.addCase(exports.getFilterSchema.fulfilled, function (state, action) {
            state.filters = action.payload;
            state.status = 'succeed';
            state.loading = false;
        });
        builder.addCase(exports.getFilterSchema.rejected, function (state) {
            state.status = 'failed';
        });
    },
});
var getDistricts = function (id, fistLoad) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var data, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch(exports.toggleLoadingStateData({ loading: true }));
                    return [4 /*yield*/, axios_1.default.get("/api/states-districts/", {
                            params: {
                                states_place_ids: fistLoad ? __spreadArray([], id) : [id],
                            },
                        })];
                case 1:
                    data = (_a.sent()).data;
                    dispatch(exports.setDistricts({ data: data.data }));
                    dispatch(exports.toggleLoadingStateData({ loading: false }));
                    return [2 /*return*/, data.data];
                case 2:
                    e_2 = _a.sent();
                    console.log(e_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.getDistricts = getDistricts;
var getBuildingNames = function (value) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var data, e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axios_1.default.get("/api/search/building-names/" + value)];
                case 1:
                    data = (_a.sent()).data;
                    dispatch(exports.setBuildingNames(data));
                    return [3 /*break*/, 3];
                case 2:
                    e_3 = _a.sent();
                    console.log(e_3);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.getBuildingNames = getBuildingNames;
var getMissingData = function (value) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var data, e_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axios_1.default.get(process.env.MIX_NOMINATIM_URL + "/search.php?q=" + value + "&polygon_geojson=1&accept-language=hy&format=jsonv2")];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
                case 2:
                    e_4 = _a.sent();
                    console.log(e_4);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.getMissingData = getMissingData;
var getMissingDataDetails = function (type, osmId, category) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var data, e_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axios_1.default.get(process.env.MIX_NOMINATIM_URL + "/details.php?osmtype=" + type + "&osmid=" + osmId + "&class=" + category + "&addressdetails=1&hierarchy=0&group_hierarchy=1&polygon_geojson=1&format=json")];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
                case 2:
                    e_5 = _a.sent();
                    console.log(e_5);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.getMissingDataDetails = getMissingDataDetails;
var getDistrictsByName = function (districtName) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var data, e_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axios_1.default.get("/api/get-state-by-district/" + districtName)];
                case 1:
                    data = (_a.sent()).data;
                    dispatch(exports.setDistrictsWithoutAppliedState({ data: data.data }));
                    return [2 /*return*/, data.district];
                case 2:
                    e_6 = _a.sent();
                    console.log(e_6);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.getDistrictsByName = getDistrictsByName;
exports.setViewBox = (_a = searchParamsSlice.actions, _a.setViewBox), exports.setCustomViewBox = _a.setCustomViewBox, exports.setCustomPlace = _a.setCustomPlace, exports.removeCustomPlace = _a.removeCustomPlace, exports.setDistricts = _a.setDistricts, exports.removeSelectedAllDistricts = _a.removeSelectedAllDistricts, exports.removeDistrictsByStateId = _a.removeDistrictsByStateId, exports.toggleLoadingStateData = _a.toggleLoadingStateData, exports.setAppliedStates = _a.setAppliedStates, exports.setBuildingNames = _a.setBuildingNames, exports.setDistrictsWithoutAppliedState = _a.setDistrictsWithoutAppliedState, exports.setSeoCleanLocationSubDirectoryPrefix = _a.setSeoCleanLocationSubDirectoryPrefix, exports.clearSeoCleanLocationSubDirectoryPrefix = _a.clearSeoCleanLocationSubDirectoryPrefix;
var useSelectCustomPlace = function (state) {
    return state.searchParams.customPlace;
};
exports.useSelectCustomPlace = useSelectCustomPlace;
var useSelectSelectedDistrictsData = function (state) {
    return state.searchParams.selectedDistrictsData;
};
exports.useSelectSelectedDistrictsData = useSelectSelectedDistrictsData;
var useSelectAppliedStates = function (state) {
    return state.searchParams.appliedStates;
};
exports.useSelectAppliedStates = useSelectAppliedStates;
var getFiltersGroup = function (state) {
    var currency = currencySlice_1.selectCurrentCurrency(state);
    if (!state.searchParams.filters) {
        return null;
    }
    // Price filters are applied based on the currency
    return reduce_1.default(state.searchParams.filters, function (acc, f, key) {
        if (f.type === 'currency') {
            acc[key] = __assign(__assign({}, f), { options: f.options.filter(function (o) {
                    var val = o.val;
                    return val.split('~')[0] === currency;
                }) });
        }
        else {
            acc[key] = f;
        }
        return acc;
    }, {});
};
exports.getFiltersGroup = getFiltersGroup;
var useSelectToggleLoadingStateData = function (state) {
    return state.searchParams.loadingStateData;
};
exports.useSelectToggleLoadingStateData = useSelectToggleLoadingStateData;
var useSelectBuildingNames = function (state) {
    return state.searchParams.buildingNames;
};
exports.useSelectBuildingNames = useSelectBuildingNames;
var useSelectSeoCleanLocationSubDirectoryPrefix = function (state) { return state.searchParams.seoCleanLocationSubDirectoryPrefix; };
exports.useSelectSeoCleanLocationSubDirectoryPrefix = useSelectSeoCleanLocationSubDirectoryPrefix;
exports.default = searchParamsSlice.reducer;
